import * as TYPES from './types';
import util from '@/common/util';
const RequestMarketReport = util.throttledRequest();

export default {
    async [TYPES.MARKET_REPORT_DISPATCH]({ state, commit }, payload) {
        const ret = await RequestMarketReport({
            url: '/api-site/snapshot/market-report',
            method: 'get',
            params: { ...payload }
        });
        commit(TYPES.SET_MARKET_REPORT_DATA, ret.marketReport);
    }
};
